import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { postHttp } from '../request/http11';

export const batchDownload = async (fileUrls, fileNames) => {
    const zip = new JSZip();
    const promises = [];
    fileUrls.forEach((item, index) => {
        const promise = postHttp(item.url,item.data,{responseType:'blob'})
          .then(res => {
                const name = item.name;
                console.log(name,res.data);
                zip.file(name, res.data, { binary: true });
            });
        promises.push(promise);
    });
    await Promise.all(promises);
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, '收藏的院校专业组相关表.zip');
};
export const batchDownload2 = async (urls) => {
  for (let i = 0; i < urls.length; i++) {
    await new Promise(resolve => {
      postHttp(urls[i].url,urls[i].data,{
        responseType: 'blob',
        // responseType: 'arraybuffer',
        'Content-Type': 'application/json'
      }).then(res => {
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        // const link = document.createElement('a');
        // link.href = URL.createObjectURL(blob);
        // link.download = urls[i].name || `file_${i}.xlsx`;
        // document.body.appendChild(link);
        // link.click();
        // setTimeout(() => {
        //   document.body.removeChild(link);
        //   URL.revokeObjectURL(link.href);
        //   resolve();
        // }, 300);
        saveAs(blob,urls[i].name);
        resolve();
      });
    });
  }
};